import {
    SET_PAYMENT_METHODS,
    SET_FIELD_FULL_NAME,
    SET_FIELD_EMAIL,
    SET_FIELD_FULL_ADDRESS,
    SET_FIELD_LOCAL_ADDRESS,
    SET_FIELD_RECIPIENT_PHONE,
    SET_FIELD_MAIN_PHONE,
    SET_FIELD_COMMENT,
    SET_FIELD_ADDRESS,
    SET_TIME_SELECTOR,
    SET_DELIVERY_TIME_MODE,
    SET_SMS_TIMEOUT,
    SET_SMS_PAYLOAD,
    SET_DELIVERY_TIME_OBJECT,
    SET_COOK_COMMENT,
    SET_LOADING,
    SET_FIELD_CUSTOM_FIELDS
} from '@/store/mutations.type'

import {
    FETCH_PRODUCTS,
    MAKE_ORDER,
    SEND_SMS
} from '@/store/actions.type'

import axios from 'axios'
import api from '@/api'

const DELIVERY_TIME = 0
const DELIVERY_DAYS_TIME = 1
const DELIVERY_MONTHS_TIME = 2
const DELIVERY_ONE_DAY = 4

const state = {
    timeSelector: true,
    deliveryTimeMode: DELIVERY_TIME,
    fieldFullName: false,
    fieldEmail: false,
    fieldFullAddress: false,
    fieldLocalAddress: true,
    fieldRecipientPhone: false,
    fieldMainPhone: true,
    fieldCustomFields: [],
    fieldComment: false,
    fieldAddress: false,
    paymentMethods: [],
    smsPayload: {},
    smsTimeout: 0,
    cookComment: '',
    deliveryTimeObject: {
        month: { value: null, data: null },
        day: { value: null, data: null },
        time: { value: null, data: null }
    }
}

const getters = {
    cookComment(state) {
        return state.cookComment
    },
    deliveryTimeObject(state) {
        return state.deliveryTimeObject
    },
    timeSelector(state) {
        return state.timeSelector
    },
    deliveryTimeMode(state) {
        return state.deliveryTimeMode
    },
    fieldFullName(state) {
        return state.fieldFullName
    },
    fieldEmail(state) {
        return state.fieldEmail
    },
    fieldFullAddress(state) {
        return state.fieldFullAddress
    },
    fieldLocalAddress(state) {
        return state.fieldLocalAddress
    },
    fieldRecipientPhone(state) {
        return state.fieldRecipientPhone
    },
    fieldMainPhone(state) {
        return state.fieldMainPhone
    },
    fieldComment(state) {
        return state.fieldComment
    },
    fieldAddress(state) {
        return state.fieldAddress
    },
    paymentMethods(state) {
        return state.paymentMethods
    },
    smsPayload(state) {
        return state.smsPayload
    },
    smsTimeout(state) {
        return state.smsTimeout
    },
    fieldCustomFields(state) {
        return state.fieldCustomFields
    },

    /**
     * @return {number}
     */
    DELIVERY_TIME() {
        return DELIVERY_TIME
    },
    /**
     * @return {number}
     */
    DELIVERY_DAYS_TIME() {
        return DELIVERY_DAYS_TIME
    },
    /**
     * @return {number}
     */
    DELIVERY_MONTHS_TIME() {
        return DELIVERY_MONTHS_TIME
    },
    DELIVERY_ONE_DAY() {
        return DELIVERY_ONE_DAY
    }

}


export const mutations = {
    [SET_DELIVERY_TIME_OBJECT](state, { month, day, time }) {
        if (month) {
            state.deliveryTimeObject.month = month
        }
        if (day) {
            state.deliveryTimeObject.day = day
        }
        if (time) {
            state.deliveryTimeObject.time = time
        }
    },
    [SET_COOK_COMMENT](state, data) {
        state.cookComment = data
    },
    [SET_FIELD_CUSTOM_FIELDS](state, data) {
        if (data) {
            state.fieldCustomFields = data
        }
    },
    [SET_TIME_SELECTOR](state, data) {
        state.timeSelector = Boolean(data)
    },
    [SET_DELIVERY_TIME_MODE](state, data) {
        state.deliveryTimeMode = data
    },
    [SET_FIELD_FULL_NAME](state, data) {
        state.fieldFullName = Boolean(data)
    },
    [SET_FIELD_EMAIL](state, data) {
        state.fieldEmail = Boolean(data)
    },
    [SET_FIELD_FULL_ADDRESS](state, data) {
        state.fieldFullAddress = Boolean(data)
    },
    [SET_FIELD_LOCAL_ADDRESS](state, data) {
        state.fieldLocalAddress = Boolean(data)
    },
    [SET_FIELD_RECIPIENT_PHONE](state, data) {
        state.fieldRecipientPhone = Boolean(data)
    },
    [SET_FIELD_MAIN_PHONE](state, data) {
        state.fieldMainPhone = Boolean(data)
    },
    [SET_FIELD_COMMENT](state, data) {
        state.fieldComment = Boolean(data)
    },
    [SET_FIELD_ADDRESS](state, data) {
        state.fieldAddress = Boolean(data)
    },
    [SET_PAYMENT_METHODS](state, data) {
        state.paymentMethods = data
    },
    [SET_SMS_PAYLOAD](state, data) {
        state.smsPayload = data
    },
    [SET_SMS_TIMEOUT](state, data) {
        state.smsTimeout = data
    }

}

export const actions = {

    [SEND_SMS](context, { phone }) {
        if (context.getters.loading[SEND_SMS]) {
            return
        }

        context.commit(SET_LOADING, { process: SEND_SMS, loading: true })

        axios({
            method: 'POST',
            url: api.sms.send.url(),
            data: {
                phone
            }
        }).then(async response => {
            context.commit(SET_SMS_PAYLOAD, response)
            context.commit(SET_SMS_TIMEOUT, 60)

            let timer = setInterval(function() {
                context.commit(SET_SMS_TIMEOUT, context.getters.smsTimeout - 1)
                if (context.getters.smsTimeout <= 0) {
                    clearInterval(timer)
                }
            }, 1000)

            // context.dispatch(FETCH_PRODUCTS)
        }).catch(error => {
            if (error.response.data.code === 2) {
                context.commit(SET_SMS_TIMEOUT, error.response.data.time)
                let timer = setInterval(function() {
                    context.commit(SET_SMS_TIMEOUT, context.getters.smsTimeout - 1)
                    if (context.getters.smsTimeout <= 0) {
                        clearInterval(timer)
                    }
                }, 1000)
            }
        }).finally(() => {
            context.commit(SET_LOADING, { process: SEND_SMS, loading: false })
            context.commit(SET_LOADING, { process: MAKE_ORDER, loading: false })
        })
    }

}

export default {
    state,
    mutations,
    getters,
    actions
}